/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hold_Button_TextInputs */

const en_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold`)
};

const id_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahan`)
};

const ms_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunggu`)
};

const ca_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperar`)
};

const cs_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podržet`)
};

const da_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vent`)
};

const de_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Warteschleife`)
};

const et_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ootele`)
};

const es_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espera`)
};

const fr_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suspendre`)
};

const hr_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadrži`)
};

const it_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni`)
};

const lv_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzgaidīt`)
};

const lt_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaukite`)
};

const hu_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előfizetés szüneteltetése`)
};

const nl_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachten`)
};

const nb_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vent`)
};

const pl_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przytrzymaj`)
};

const pt_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperar`)
};

const ro_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Așteaptă`)
};

const sk_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podržať`)
};

const sl_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čakanje`)
};

const fi_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pidä`)
};

const sv_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vänta`)
};

const vi_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giữ`)
};

const tr_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beklet`)
};

const el_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναμονή`)
};

const bg_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задържане`)
};

const ru_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Держать`)
};

const sr_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задржи`)
};

const uk_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Призупинити`)
};

const ka_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დაყოვნება`)
};

const hi_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`होल्ड`)
};

const th_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถือ`)
};

const ko_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보류`)
};

const zh_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留`)
};

const zh_tw_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暫停`)
};

const ja_hold_button_text = /** @type {(inputs: Hold_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留`)
};

/**
* | output |
* | --- |
* | "Hold" |
*
* @param {Hold_Button_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const hold_button_text = /** @type {((inputs?: Hold_Button_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hold_Button_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hold_button_text(inputs)
	if (locale === "ms") return ms_hold_button_text(inputs)
	if (locale === "ca") return ca_hold_button_text(inputs)
	if (locale === "cs") return cs_hold_button_text(inputs)
	if (locale === "da") return da_hold_button_text(inputs)
	if (locale === "de") return de_hold_button_text(inputs)
	if (locale === "et") return et_hold_button_text(inputs)
	if (locale === "es") return es_hold_button_text(inputs)
	if (locale === "fr") return fr_hold_button_text(inputs)
	if (locale === "hr") return hr_hold_button_text(inputs)
	if (locale === "it") return it_hold_button_text(inputs)
	if (locale === "lv") return lv_hold_button_text(inputs)
	if (locale === "lt") return lt_hold_button_text(inputs)
	if (locale === "hu") return hu_hold_button_text(inputs)
	if (locale === "nl") return nl_hold_button_text(inputs)
	if (locale === "nb") return nb_hold_button_text(inputs)
	if (locale === "pl") return pl_hold_button_text(inputs)
	if (locale === "pt") return pt_hold_button_text(inputs)
	if (locale === "ro") return ro_hold_button_text(inputs)
	if (locale === "sk") return sk_hold_button_text(inputs)
	if (locale === "sl") return sl_hold_button_text(inputs)
	if (locale === "fi") return fi_hold_button_text(inputs)
	if (locale === "sv") return sv_hold_button_text(inputs)
	if (locale === "vi") return vi_hold_button_text(inputs)
	if (locale === "tr") return tr_hold_button_text(inputs)
	if (locale === "el") return el_hold_button_text(inputs)
	if (locale === "bg") return bg_hold_button_text(inputs)
	if (locale === "ru") return ru_hold_button_text(inputs)
	if (locale === "sr") return sr_hold_button_text(inputs)
	if (locale === "uk") return uk_hold_button_text(inputs)
	if (locale === "ka") return ka_hold_button_text(inputs)
	if (locale === "hi") return hi_hold_button_text(inputs)
	if (locale === "th") return th_hold_button_text(inputs)
	if (locale === "ko") return ko_hold_button_text(inputs)
	if (locale === "zh") return zh_hold_button_text(inputs)
	if (locale === "zh-tw") return zh_tw_hold_button_text(inputs)
	if (locale === "ja") return ja_hold_button_text(inputs)
	return en_hold_button_text(inputs)
});